export default "__VITE_ASSET__BCUiHCJ1__"